if ($('.in-index').length) {
  $(document).ready(function(){  
    var myCarousels = $(".carousel");
    myCarousels.each(function( index, element  ) {
      var myCarousel = $("#"+$(element).attr('id')); 
      myCarousel.append("<ol class='carousel-indicators'></ol>");
      var indicators = $("#"+$(element).attr('id') + " .carousel-indicators"); 
      $("#"+$(element).attr('id') +" .carousel-inner").children(".item").each(function(index) {
          console.log(index);
          (index === 0) ? 
          indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"' class='active'></li>") : 
          indicators.append("<li data-target='#"+$(element).attr('id')+"' data-slide-to='"+index+"'></li>");
      });
    });
  });
}

if ($('.logo-slider').length) {
  $(".logo-slider .slider-wrap").slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: false,
    autoplay: true,
    dots: true,
    arrows: false,
    responsive:[
      {
        breakpoint:991,
        settings:
        {
          slidesToShow:4
        }
      },
      {
        breakpoint:767,
        settings:{
          slidesToShow:3
        }
      },
      {
        breakpoint:479,
        settings:{
          slidesToShow:2
        }
      }
    ]
  });
}